



















import Vue from 'vue';
import CustomButton from '../../layout/buttons/CustomButton.vue';

export default Vue.extend({
  name: `VoucherAssignmentMailSentNotification`,
  components: { CustomButton },
  props: {
    customerName: {
      required: true,
      type: String,
    },
  },
});
